const FallbackLoading = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="loader"></div>
    </div>
  );
};

export default FallbackLoading;
